const logisticLocation = {
    'TITLE': 'Location Mapping',
}

export default logisticLocation;